

import React from 'react';
import { Spin, Form, Input, Button, Row, Col } from 'antd';
import { SMS_COUNTRY_CODES, SMS_TEXT } from '../../../constants/constants';

const onFinish = (props, values, { resetFields }) => {
  const { sendSms } = props;
  const msg = SMS_TEXT;
  const { code } = SMS_COUNTRY_CODES.find(({ country }) => country === 'AUS');

  let phone = `${code}${values.phone}`;
  sendSms({ phone, msg }).then(() => resetFields());
};

const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo);
};

const GetTheAppSection = (props) => {
  const { data, loading } = props;
  const { description, content } = data || {};
  const { app_title: appTitle, app_subtitle: appSubtitle } = content ? JSON.parse(content) : {};
  const [form] = Form.useForm();
  return (
    <div>
      <Spin spinning={loading}>
        <section className="icause_app get-app-section">
          <Form
            form={form}
            layout="vertical"
            name="basic"
            onFinish={(values) => onFinish(props, values, form)}
            onFinishFailed={onFinishFailed}
          >
            <div className="container">
              <h3 className="main-heading text-center pb-1">
                <div dangerouslySetInnerHTML={{ __html: appTitle || '' }} />
              </h3>
              <div className="row  d-flex align-items-center">
                <div className="col-lg-5 col-md-6 col-sm-12">
                  <h2>
                    <div dangerouslySetInnerHTML={{ __html: appSubtitle || '' }} />
                  </h2>
                  <p className="">{description || ''}</p>
                  <Form.Item
                    name="phone"
                    rules={[
                      {
                        required: true,
                        max: 9,
                        min: 9,
                        message: 'Please input a valid phone number!',
                      },
                    ]}>
                    <div>
                      <Row gutter={24} className="input-wrap">
                        <Col style={{ marginTop: '7px', paddingLeft: '10px', paddingRight: '0px' }} span={4}>
                          <h5>(+61)</h5>
                        </Col>
                        <Col span={20}>
                          <Input style={{ height: '40px', fontSize: '17px', backgroundColor: '#ECF4FA' }} className="form-control" type='number' placeholder='Enter Phone Number' />
                        </Col>
                      </Row>
                    </div>
                  </Form.Item>
                  <Form.Item>
                    <Button style={{ height: '48px' }} htmlType='submit' type='primary' className="btn btn-success btn-block get-app-btn">Get the app</Button>
                  </Form.Item>
                  {/* <p className="text-center my-3">Available on</p> */}
                  {/* <button type="button" className="btn bg-one"></button>
                  <button type="button" className="btn ml-1 bg-two"></button> */}
                  <div className="available-on">
                    <p>Available on</p>
                    <button type="button"><img src="/images/app-store-2.png" alt="app-store" className="img-fluid" /></button>
                    <button type="button"><img src="/images/play-store-2.png" alt="play-store" className="img-fluid" /></button>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 icause-phone-wrap"> 
                  <img src="/images/iPhoneX-dock-2.png" className="img-fluid" alt="" /> 
                </div>
              </div>
            </div>
          </Form>
        </section>
      </Spin>
    </div>
  );
};

export default GetTheAppSection;
